module.exports = "/assets/data/0dd7a70b819a2c25892db755ea3a47d2-N1C.data.json";